import type { ChatRoomResponseBasicInfo } from './chatRoomResponseBasicInfo';
import type { ChatRoomResponseLastMessage } from './chatRoomResponseLastMessage';
import type { ChatRoomResponseParticipantsItem } from './chatRoomResponseParticipantsItem';
import type { ChatRoomResponseTimeInfo } from './chatRoomResponseTimeInfo';

export interface ChatRoomResponse {
  basicInfo?: ChatRoomResponseBasicInfo;
  /** 마지막 메시지 */
  lastMessage?: ChatRoomResponseLastMessage;
  /** 참여자 목록 */
  participants?: ChatRoomResponseParticipantsItem[];
  /** 시간 관련 정보 */
  timeInfo?: ChatRoomResponseTimeInfo;
}
